import React, { useState } from "react";
import banner from "../../Asset/OUR PRODUCTS BANNER_UPDATED.png";

// Existing product images
import tmt from "../../Asset/306.jpg";
import angles from "../../Asset/5315927.jpg";
import channels from "../../Asset/mscahnnel.jpg";
import beams from "../../Asset/153.jpg";
import rounds from "../../Asset/msrounds.png";
import flat1 from "../../Asset/product01.jpg";
import roofing1 from "../../Asset/product02.jpg";
import hrsheet from "../../Asset/ms-hr-sheet-500x500.webp";
import msplate from "../../Asset/msplate.jpg";
import msflats from "../../Asset/MS FLATS_GI FLATS.jpg";
import CHEQUERED from "../../Asset/CHEQUERED.jpg";
import roof1 from "../../Asset/Roofing Sheets.jpg";
import roof2 from "../../Asset/roofing-accessories.jpg";

// New JSW products
import jswCement from "../../Asset/jsw-cement-1.jpg";
import jswInterior from "../../Asset/Pixa Joie Classic Interiors.png";
import jswExterior from "../../Asset/Pixa Joie Classic Exteriors.png";
import jswWaterproof from "../../Asset/Waterproofing-Solutions-rhs.png";
import jswEnamel from "../../Asset/colordur-DTM-PU enamel-gloss_0.png";

// Tabs
const tabs = [
  { key: "long", label: "Long Products" },
  { key: "flat", label: "Flat Products" },
  { key: "roofing", label: "Roofing Sheets" },
  { key: "jswcement", label: "JSW Cement" },
  { key: "jswpaints", label: "JSW Paints" },
];

// Product Data
const productData = {
  long: [
    {
      id: 1,
      name: "TMT Rebars",
      image: tmt,
      desc: "SAIL TMT Bar is high strength reinforcement bar ideal for any kind of construction project...",
    },
    {
      id: 2,
      name: "MS Angles",
      image: angles,
      desc: "We offer the finest quality MS Angles, used extensively in the fabrication industry...",
    },
    {
      id: 3,
      name: "MS Channels",
      image: channels,
      desc: "High-quality MS Channels, especially ISMC 100, used widely in structural frameworks...",
    },
    {
      id: 4,
      name: "MS Beams",
      image: beams,
      desc: "MS Joists with H cross-section used in major structural support applications...",
    },
    {
      id: 5,
      name: "MS Rounds",
      image: rounds,
      desc: "Premium corrosion-resistant MS rounds ideal for multiple industrial applications...",
    },
  ],
  flat: [
    {
      id: 6,
      name: "HR SHEETS",
      image: hrsheet,
      desc: "Cut-to-length hot-rolled steel sheets for structural and industrial applications...",
    },
    {
      id: 7,
      name: "M.S. PLATES",
      image: msplate,
      desc: "Mild Steel and alloy steel plates suitable for manufacturing and construction...",
    },
    {
      id: 8,
      name: "MS FLATS / GI FLATS",
      image: msflats,
      desc: "Durable mild steel and galvanized iron flats used for construction and fabrication...",
    },
    {
      id: 9,
      name: "CHEQUERED PLATES",
      image: CHEQUERED,
      desc: "Steel chequered plates used for robust structural frameworks...",
    },
  ],
  roofing: [
    {
      id: 10,
      name: "METAL ROOFING COLOR SHEETS",
      image: roof1,
      desc: "Durable and aesthetic metal roofing sheets available in vibrant colors...",
    },
    {
      id: 11,
      name: "ROOFING ACCESSORIES",
      image: roof2,
      desc: "Color-coated roofing accessories that complement metal sheets...",
    },
  ],
  jswcement: [
    {
      id: 12,
      name: "JSW Cement",
      image: jswCement,
      desc: "JSW Cement offers unmatched strength, durability, and eco-friendliness...",
    },
  ],
  jswpaints: [
    {
      id: 13,
      name: "JSW Paints – Interior Emulsion",
      image: jswInterior,
      desc: "Elegant, low-VOC interior paints with rich matte finish and excellent washability...",
    },
    {
      id: 14,
      name: "JSW Paints – Exterior Emulsion",
      image: jswExterior,
      desc: "Long-lasting exterior paints offering excellent UV and weather resistance...",
    },
    {
      id: 15,
      name: "JSW Paints – Waterproof Coating",
      image: jswWaterproof,
      desc: "Advanced waterproofing solution for walls and roofs...",
    },
    {
      id: 16,
      name: "JSW Paints – Metal Enamel",
      image: jswEnamel,
      desc: "Premium enamel paint for metal surfaces offering anti-rust protection...",
    },
  ],
};

// Main Component
const Products = () => {
  const [activeTab, setActiveTab] = useState("long");

  return (
    <div className="w-full bg-white">
      {/* Banner */}
      <section>
        <img src={banner} alt="Product Banner" className="w-full object-cover" />
      </section>

      {/* Tabs */}
      <div className="bg-[#114497] text-white text-center py-6 shadow-md">
        <div className="flex justify-center gap-4 flex-wrap">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`px-6 py-2 rounded-full font-medium border transition-all duration-300 transform ${
                activeTab === tab.key
                  ? "bg-[#fbb613] text-[#114497] scale-105 shadow-md"
                  : "border-white text-white hover:bg-white hover:text-[#114497] hover:scale-105"
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Section Heading */}
      <div className="text-center mt-10 mb-6">
        <h2 className="text-3xl font-bold text-[#114497] mb-2">Our Products</h2>
        <p className="text-gray-600">
          Explore premium steel and construction products built for strength and durability
        </p>
      </div>

      {/* Product Grid */}
      <div className="max-w-7xl mx-auto px-4 py-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {productData[activeTab].map((product) => (
            <div
              key={product.id}
              className="bg-white shadow-xl rounded-2xl overflow-hidden border border-gray-200 hover:shadow-2xl transition transform hover:-translate-y-1"
            >
              <div className="overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-52  object-contain hover:scale-105 transition duration-300"
                />
              </div>
              <div className="p-5 text-center">
                <h3 className="text-lg font-bold text-[#114497] mb-2">
                  {product.name}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed line-clamp-4">
                  {product.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products;
